import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthGuardService, FormbuilderGuardService, ReportingGuardService } from '@shared/services/api/auth.service';
import { HtmlEditorComponent } from './pages/html-editor/htmlEditor.component';
import { TaskLinkComponent } from './pages/tasklink/tasklink.component';

const routes: Routes = [
    { path: '', redirectTo: 'app/home', pathMatch: 'full' },
    {
        path: "app/home",
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: true },
    },
    {
      path: "app/user-form",
      loadChildren: () => import('./pages/management/user-form/user-form.module').then(m => m.UserFormModule),
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { animation: true, useTheme: true },
    },
    {
      path: "app/usergroups-form",
      loadChildren: () => import('./pages/management/usergroups-form/usergroups-form.module').then(m => m.UserGroupsFormModule),
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { animation: true, useTheme: true },
    },
    {
      path: "app/settings",
      loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
      canActivate: [AuthGuardService],
      pathMatch: 'full',
      data: { animation: true, useTheme: true },
    },
    {
        path: "app/analytics",
        loadChildren: () => import('./pages/analytics/analytics.module').then(m => m.AnalyticsModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: true },
    },
    {
        path: "app/analyticsmobile",
        loadChildren: () => import('./pages/analytics/analytics.module').then(m => m.AnalyticsModule),
        canActivate: [FormbuilderGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },   
    {
        path: "app/menu/:id/:formId/:schemaId",
        loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: true },
    },
    {
        path: "app/formbuilder",
        loadChildren: () => import('./pages/formbuilder/formbuilder.module').then(m => m.FormbuilderModule),
        canActivate: [FormbuilderGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },
    {
        path: "app/reportdesigner",
        loadChildren: () => import('./pages/report/_report_designer/reportdesigner.module').then(m => m.ReportDesignerModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },
    {
        path: "mobilwhitepage/:reportGuid",
        loadChildren: () => import('./pages/mobil-whitepage/mobilwhitepage.module').then(m => m.MobileWhitePageModule),
        canActivate: [FormbuilderGuardService],
        data: { animation: true, useTheme: false }
    },
    {
        path: "app/report",
        loadChildren: () => import('./pages/report/_report_viewer/reportviewer.module').then(m => m.ReportViewerModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: true }
    },
    {
        path: "app/pagedesigner",
        loadChildren: () => import('./pages/board/page-designer/page-designer.module').then(m => m.PageDesignerModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },
    {
        path: "app/pageviewer",
        loadChildren: () => import('./pages/board/page-viewer/page-viewer.module').then(m => m.PageViewerModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: true }
    },
    {
        path: "app/pageviewermobile",
        loadChildren: () => import('./pages/board/page-viewer/page-viewer.module').then(m => m.PageViewerModule),       
        canActivate: [FormbuilderGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },
    {
        path: "app/profile",
        loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuardService],
        data: { animation: true, useTheme: true }
  },
  {
    path: "mobildashboard/:reportId/:userId/:params",
    loadChildren: () => import('./pages/mobile-dashboard/mobile-dashboard.module').then(m => m.MobileDashboardModule),
    canActivate: [FormbuilderGuardService],
    pathMatch: 'full',
    data: { animation: true, useTheme: false }
  },
  {
    path: "mobildashboard/:reportId/:userId",
    loadChildren: () => import('./pages/mobile-dashboard/mobile-dashboard.module').then(m => m.MobileDashboardModule),
    canActivate: [FormbuilderGuardService],
    pathMatch: 'full',
    data: { animation: true, useTheme: false }
  },
    {
        path: "app/filemanagement",
        loadChildren: () => import('./pages/filemanagement/filemanagement.module').then(m => m.FileManagementModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },
    {
        path: "app/filemanagement/:parentobj",
        loadChildren: () => import('./pages/filemanagement/filemanagement.module').then(m => m.FileManagementModule),
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },
    {
        path: "login",
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
        data: { animation: true, useTheme: false }
    },
    {
        path: "r/:fileKey",
        loadChildren: () => import('./pages/fm-link/fm-link.module').then(m => m.FmLinkModule),
        data: { animation: true, useTheme: false }
    },
    {
        path: "outlook",
        loadChildren: () => import('./pages/outlook/outlook.module').then(m => m.OutlookModule),
        data: { animation: true, useTheme: false }
    },
    {
        path: "app/email",
        loadChildren: () => import('./pages/email/email.module').then(m => m.EmailModule),
        canActivate: [AuthGuardService],
        //pathMatch: 'full',
        data: { animation: true, useTheme: true }
    },
    {
        path: "htmleditor",
        loadChildren: () => import('./pages/html-editor/htmlEditor.module').then(m => m.HtmlEditorModule),
        canActivate: [AuthGuardService],
        component: HtmlEditorComponent,
        pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },   
    {
        path: "tasklink/:guid",
        loadChildren: () => import('./pages/tasklink/tasklink.module').then(m => m.TasklinkModule),
        //component: TaskLinkComponent,
        //pathMatch: 'full',
        data: { animation: true, useTheme: false }
    },  
    {
        path: 'anonim-form',
        loadChildren: () => import('./pages/anonim-form/anonim-form.module').then(m => m.AnonimFormModule),
        data: { animation: true, useTheme: false }
    },
    {
        path: 'anonim-form/:guid',
        loadChildren: () => import('./pages/anonim-form/anonim-form.module').then(m => m.AnonimFormModule),
        data: { animation: true, useTheme: false }
    },
    {
      path: 'reset-password',
      loadChildren: () => import('./pages/password-change/password-change.module').then(m => m.PasswordChangeModule),
      data: { animation: true, useTheme: false }
    },
    { path: '**', redirectTo: 'login' }
];


@NgModule({
    imports: [
        RouterModule.forRoot(routes, { enableTracing: false }),
    ],
    exports: [RouterModule],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class AppRoutingModule { }
